<div class="fs-2 with-close" mat-dialog-title>
    Modification des caractéristiques
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="card-text row">
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Ascenseur</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.elevator">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Vente urgente</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.urgent">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Déja loué</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.rent">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Travaux à prévoir</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.work">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Sans travaux</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.renov">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Vendu par un particulier</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.owner_type">
                    <mat-option value="pro">Non</mat-option>
                    <mat-option value="private">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Accès handicapé</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.disabled_access">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Gardien</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.guardian">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Interphone</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.intercom">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Sans vis-à-vis</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.closed_view">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>Digicode</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.digital_code">
                    <mat-option [value]="false">Non</mat-option>
                    <mat-option [value]="true">Oui</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()"  class="btn btn-primary">
        Valider
    </button>
</div>


